import MultiTourHandlerSingleton from 'ui-shepherd-react/lib/MultiTourHandlerSingleton';
import { ONBOARDING_FORECAST_TOUR, ONBOARDING_FORECAST_TOUR_WITHOUT_AI, ONBOARDING_FORECAST_REP_TABLE, ONBOARDING_FORECAST_CATEGORY_TAB, ONBOARDING_ANALYZE_TAB, ONBOARDING_FORECAST_SUBMISSION, EXISTING_USER_FMO_TOUR, FMO_TOUR_DROPDOWN_STEP, FMO_TOUR_CREATE_FORECAST_STEP, ONBOARDING_V2_TOUR, ONBOARDING_V2_TOUR_WITHOUT_ANALYZE } from '../constants/TourConstants';
const tourHandler = MultiTourHandlerSingleton.getInstance();
tourHandler.registerTour(ONBOARDING_FORECAST_TOUR, {
  steps: [ONBOARDING_FORECAST_REP_TABLE, ONBOARDING_FORECAST_CATEGORY_TAB, ONBOARDING_ANALYZE_TAB, ONBOARDING_FORECAST_SUBMISSION]
});
tourHandler.registerTour(ONBOARDING_FORECAST_TOUR_WITHOUT_AI, {
  steps: [ONBOARDING_FORECAST_REP_TABLE, ONBOARDING_FORECAST_CATEGORY_TAB, ONBOARDING_FORECAST_SUBMISSION]
});
tourHandler.registerTour(EXISTING_USER_FMO_TOUR, {
  steps: [FMO_TOUR_CREATE_FORECAST_STEP, FMO_TOUR_DROPDOWN_STEP]
});

// Onboarding V2 Tour
tourHandler.registerTour(ONBOARDING_V2_TOUR, {
  steps: [FMO_TOUR_DROPDOWN_STEP, ONBOARDING_FORECAST_CATEGORY_TAB, ONBOARDING_ANALYZE_TAB, ONBOARDING_FORECAST_SUBMISSION]
});
tourHandler.registerTour(ONBOARDING_V2_TOUR_WITHOUT_ANALYZE, {
  steps: [FMO_TOUR_DROPDOWN_STEP, ONBOARDING_FORECAST_CATEGORY_TAB, ONBOARDING_FORECAST_SUBMISSION]
});
export default tourHandler;